var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.searchBar)?_c('search-bar-filter',{attrs:{"featureConfig":_vm.searchBar}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }